var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 16.5C14.6663 15.337 14.6663 14.7555 14.5228 14.2824C14.1996 13.217 13.366 12.3834 12.3006 12.0602C11.8275 11.9167 11.246 11.9167 10.083 11.9167H5.91634C4.75337 11.9167 4.17189 11.9167 3.69872 12.0602C2.63339 12.3834 1.79971 13.217 1.47654 14.2824C1.33301 14.7555 1.33301 15.337 1.33301 16.5M11.7497 5.25C11.7497 7.32107 10.0707 9 7.99967 9C5.92861 9 4.24967 7.32107 4.24967 5.25C4.24967 3.17893 5.92861 1.5 7.99967 1.5C10.0707 1.5 11.7497 3.17893 11.7497 5.25Z",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.5e42259cb9d6c5e22ae21712223b3769.svg";
export { ForwardRef as ReactComponent };